export const notificationConstants = {
  FETCHING_NOTIFICATIONS: 'FETCHING_NOTIFICATIONS',
  GET_NOTIFICATIONS_SUCCESS: 'GET_NOTIFICATIONS_SUCCESS',
  FETCHED_NOTIFICATIONS: 'FETCHED_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  GET_NOTIFICATIONS_COUNT_SUCCESS: 'GET_NOTIFICATIONS_COUNT_SUCCESS'
};
